import { ENDPOINT, RELATIONSHIP_FIELD } from "../utils/constants";
import { request } from "../utils/request";
import { getCurrentSiteId } from "../utils/util";

export const getCurrentCertification = async (assetId) => {
	const data = await request({
		url: `${ENDPOINT.CERTIFICATIONS}/${assetId}`,
		method: "get",
	});
	return data;
};

export const getCertificationsList = async () => {
	const data = await request({
		url: `${ENDPOINT.CERTIFICATIONS}`,
		method: "get",
	});
	return data.items;
};

export const getAssessments = async (assetId) => {
	const data = await request({
		url: `${
			ENDPOINT.ASSESSMENTS
		}?fields=id,title,description,url,durationMinutes&filter=${
			RELATIONSHIP_FIELD.CERTIFICATIONS_IN_ASSESSMENTS
		} eq '${assetId}'`,
		method: "get",
	});
	return data.items;
};

export const getLearningPathsIdFromAssessments = async () => {
	const data = await request({
		url: `${ENDPOINT.LEARNING_PATHS}?fields=id,${RELATIONSHIP_FIELD.ASSESSMENTS_IN_LEARNING_PATHS}`,
		method: "get",
	});
	return data.items
}

export const getCertificationTemplateBase64 = async () => {
	try {
		const data = await request({
			url: `/o/headless-delivery/v1.0/sites/${getCurrentSiteId()}/documents/by-external-reference-code/LIFERAY_CERTIFICATION_TEMPLATE?fields=contentUrl`,
			method: "get",
		});

		const response = await fetch(window.location.origin + data.contentUrl);

		if (!response.ok) return null;

		const blob = await response.blob();

		return await new Promise((resolve) => {
			const reader = new FileReader();

			reader.onloadend = () => resolve(reader.result);
			reader.readAsDataURL(blob);
		});
	} catch {
		return null;
	}
};